import React, { PropsWithChildren } from "react";
//#region types
import { ContentTreeNodeProps } from "models/propTypes/contentTreePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ContentNode: React.FC<PropsWithChildren<ContentTreeNodeProps>> = (props) => {
  const { currentIndex, parentIndex } = props;

  return (
    <Grid
      container
      item
      className={clsx(cssExports.description)}
      key={`tree-${parentIndex}subTree-${currentIndex}`}
      wrap="nowrap"
      direction="row"
    >
      <Grid item className={cssExports.indexDescription}>
        {`${parentIndex}. ${currentIndex}`}
      </Grid>
      <Grid item xs>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default ContentNode;
